/**
 * @generated SignedSource<<2e4117c270d103eddad49e501fd232a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CancelStage = "CancelImpossible" | "CancelPossibleAfterDeclare" | "CancelPossibleBeforeDeclare" | "CancelPossibleImmediately" | "Canceling";
export type RefundStage = "Declare" | "PaymentComplete" | "RefundCompleteA" | "RefundCompleteB" | "RefundDetermine" | "RefundPreDetermine" | "Review" | "Unknown";
export type RefundStatus = "ApplyComplete" | "ApplyImpossible" | "ApplyPossible" | "Complete" | "Impossible" | "None" | "Possible" | "RefundFinish" | "RefundImpossible" | "Retry";
export type applyResultContentQuery$variables = Record<PropertyKey, never>;
export type applyResultContentQuery$data = {
  readonly bznavRefund: {
    readonly user: {
      readonly corps: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly applicationInfo: {
          readonly accountNo: string | null | undefined;
          readonly bank: string | null | undefined;
        } | null | undefined;
        readonly businessInfo: {
          readonly hometaxBizName: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly depositExpectDt: string | null | undefined;
        readonly partnerInfo: {
          readonly defaultFeeRate: string;
          readonly discountRate: string;
          readonly feeRate: string;
        } | null | undefined;
        readonly paymentDate: string | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
        readonly refundResultDt: string | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly virtualAccountInfo: {
          readonly account: string;
          readonly bank: string;
          readonly owner: string;
          readonly paymentAmount: string;
        } | null | undefined;
      }> | null | undefined;
      readonly indis: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly applicationInfo: {
          readonly accountNo: string | null | undefined;
          readonly bank: string | null | undefined;
        } | null | undefined;
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly depositExpectDt: string | null | undefined;
        readonly partnerInfo: {
          readonly defaultFeeRate: string;
          readonly discountRate: string;
          readonly feeRate: string;
        } | null | undefined;
        readonly paymentDate: string | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
        readonly refundResultDt: string | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly virtualAccountInfo: {
          readonly account: string;
          readonly bank: string;
          readonly owner: string;
          readonly paymentAmount: string;
        } | null | undefined;
      }> | null | undefined;
      readonly previousIndis: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly applicationInfo: {
          readonly accountNo: string | null | undefined;
          readonly bank: string | null | undefined;
        } | null | undefined;
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly depositExpectDt: string | null | undefined;
        readonly partnerInfo: {
          readonly defaultFeeRate: string;
          readonly discountRate: string;
          readonly feeRate: string;
        } | null | undefined;
        readonly paymentDate: string | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
        readonly refundResultDt: string | null | undefined;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
        readonly virtualAccountInfo: {
          readonly account: string;
          readonly bank: string;
          readonly owner: string;
          readonly paymentAmount: string;
        } | null | undefined;
      }> | null | undefined;
      readonly tritxIndis: ReadonlyArray<{
        readonly applicationDt: string | null | undefined;
        readonly applicationInfo: {
          readonly accountNo: string | null | undefined;
          readonly bank: string | null | undefined;
        } | null | undefined;
        readonly businessInfo: {
          readonly taxpayerName: string | null | undefined;
        } | null | undefined;
        readonly cancelStage: CancelStage | null | undefined;
        readonly partnerInfo: {
          readonly defaultFeeRate: string;
          readonly discountRate: string;
          readonly feeRate: string;
        } | null | undefined;
        readonly refundAmount: string;
        readonly refundId: string;
        readonly refundStage: RefundStage | null | undefined;
        readonly refundStatus: RefundStatus;
      }> | null | undefined;
    };
  };
};
export type applyResultContentQuery = {
  response: applyResultContentQuery$data;
  variables: applyResultContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "applicationDt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundResultDt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "depositExpectDt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundAmount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStatus",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "refundStage",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelStage",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessInfo",
  "kind": "LinkedField",
  "name": "businessInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taxpayerName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bank",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ApplicationInfo",
  "kind": "LinkedField",
  "name": "applicationInfo",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountNo",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "VirtualAccountType",
  "kind": "LinkedField",
  "name": "virtualAccountInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "account",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentAmount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "RefundPartnerType",
  "kind": "LinkedField",
  "name": "partnerInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultFeeRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "feeRate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "discountRate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "BusinessInfo",
  "kind": "LinkedField",
  "name": "businessInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hometaxBizName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "applyResultContentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": (v14/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "tritxIndis",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v15/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "applyResultContentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BznavRefundOutput",
        "kind": "LinkedField",
        "name": "bznavRefund",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RefundUserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "indis",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "previousIndis",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "tritxIndis",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v5/*: any*/),
                  (v1/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v9/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RefundHistoryType",
                "kind": "LinkedField",
                "name": "corps",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v3/*: any*/),
                  (v15/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f69bc6d92255f3b68caa35fa0c5a2fcc",
    "id": null,
    "metadata": {},
    "name": "applyResultContentQuery",
    "operationKind": "query",
    "text": "query applyResultContentQuery {\n  bznavRefund {\n    user {\n      indis {\n        refundId\n        applicationDt\n        refundResultDt\n        paymentDate\n        depositExpectDt\n        refundAmount\n        refundStatus\n        refundStage\n        cancelStage\n        businessInfo {\n          taxpayerName\n        }\n        applicationInfo {\n          bank\n          accountNo\n        }\n        virtualAccountInfo {\n          owner\n          bank\n          account\n          paymentAmount\n        }\n        partnerInfo {\n          defaultFeeRate\n          feeRate\n          discountRate\n        }\n        id\n      }\n      previousIndis {\n        refundId\n        applicationDt\n        refundResultDt\n        paymentDate\n        depositExpectDt\n        refundAmount\n        refundStatus\n        refundStage\n        cancelStage\n        businessInfo {\n          taxpayerName\n        }\n        applicationInfo {\n          bank\n          accountNo\n        }\n        virtualAccountInfo {\n          owner\n          bank\n          account\n          paymentAmount\n        }\n        partnerInfo {\n          defaultFeeRate\n          feeRate\n          discountRate\n        }\n        id\n      }\n      tritxIndis {\n        refundId\n        refundAmount\n        applicationDt\n        refundStatus\n        refundStage\n        cancelStage\n        applicationInfo {\n          bank\n          accountNo\n        }\n        businessInfo {\n          taxpayerName\n        }\n        partnerInfo {\n          defaultFeeRate\n          feeRate\n          discountRate\n        }\n        id\n      }\n      corps {\n        refundId\n        applicationDt\n        refundResultDt\n        depositExpectDt\n        refundAmount\n        refundStatus\n        refundStage\n        cancelStage\n        paymentDate\n        businessInfo {\n          hometaxBizName\n        }\n        applicationInfo {\n          bank\n          accountNo\n        }\n        virtualAccountInfo {\n          owner\n          bank\n          account\n          paymentAmount\n        }\n        partnerInfo {\n          defaultFeeRate\n          feeRate\n          discountRate\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dc64cf0ac8a052036f26b602bf9e906";

export default node;
